import { useEffect, useState } from "react";
import TextFields from "../TextField/text-field.component"; // DropDownTextField,
import {
  PreviewOfPaymentModalWrapper,
  PreviewOfPaymentModalContainer,
  PreviewOfPaymentHeader,
  PreviewOfPaymentSubHeader,
  PreviewOfPaymentDetailsModal,
  PreviewOfPaymentImageField,
  PreviewOfPaymentInfo,
  Label,
  PreviewOfPaymentInformation,
  ProductDisplayContainer,
  PreviewItemsContainer,
  PreviewItemsTitle,
  PreviewItemsDescription,
  PreviewPriceCont,
  PreviewPriceText,
  PreviewEmailContainer,
  PreviewSmallInput,
  PreviewLargeInput,
  PreviewPhoneBox,
  PreviewPaymentPhoneContainer,
  PreviewPaymentInputMain,
  PreviewPaymentInput1,
  PreviewPaymentInput2,
  PreviewPaymentInput3,
  PreviewPaymentInput4,
  PreviewPaymentContent1,
  PreviewPaymentContent2,
  PreviewPaymentContent3,
  PreviewPaymentMainCon,
  SelectPaymentOptionPaymentLink,
  PaymentWithAccount,
  RadioButton,
  PreviewPaymentButtonContainer,
  SpanStyles,
  PaymentOptionsSelect,
  PaymentWithCardSpan,
  PreviewPriceCont1,
  PreviewTaxContainer,
  PreviewPaymentConfirmation,
  PreviewAmount,
  PreviewAmountTitle,
  PreviewAmountValue,
  PreviewAmountSmallTitle,
  PreviewAmountSmallValue,
  MainPreviewSubSpan,
} from "./PreviewOfPayment.styles";

import fipayFonts from "../../theme/index";
import Buttons from "../Button/button.component";
import { colors } from "../../theme/color";
import { LouisannaBag, CharityPreviewIcon } from "../../../public/assets";
import { GET_ALL_PRODUCTS } from "../../graphql/queries/paymentlink";
import { useQuery } from "@apollo/client";
import { useDispatch, useSelector } from "react-redux";
interface ShowCardData {
  showAddress?: string;
  showTaxInfo?: any;
  searchProductData?: any;
  storageData?: any;
}

const PreviewOfPayment: React.FC<ShowCardData> = ({
  showAddress,
  showTaxInfo,
  searchProductData,
}) => {
  const [data, setData] = useState({
    quantity: "",
    email: "",
    taxId: "",
    addressLine1: "",
    addressLine2: "",
    city: "",
    zip: "",
  });
  const {
    loading,
    error,
    data: getAlldata,
  } = useQuery(GET_ALL_PRODUCTS, {
    variables: { service: "payment-link" },
  });

  const selector = useSelector((state: any) => state.products);
  const user = useSelector((state: any) => state.user);

  const [phone, setPhone] = useState("");
  const [oneTimeChecked, setOneTimeChecked] = useState(false);
  const [recurringChecked, setRecurringChecked] = useState(false);
  const [totalPrice, setTotalPrice] = useState<string>("0.00");

  const isFormValid = (): boolean => {
    const isEmailValid = data.email !== "";
    const isPhoneValid = phone !== "";
    const isPaymentOptionSelected = oneTimeChecked || recurringChecked;
    return isEmailValid && isPhoneValid && isPaymentOptionSelected;
  };

  const handleNameChange = (key: string, value: string) => {
    setData((prevData) => ({
      ...prevData,
      [key]: value,
    }));
  };

  const handleOneTimeClick = () => {
    setOneTimeChecked(true);
    setRecurringChecked(false);
  };

  const handleRecurringClick = () => {
    setOneTimeChecked(false);
    setRecurringChecked(true);
  };

  const handlePhoneChange = (e: any) => {
    setPhone(e.target.value);
  };

  const handleAddress: any = (e: any) => {
    setData(e.target.value);
  };

  useEffect(() => {
    if (!loading && searchProductData?.length > 0) {
      const totalPrice = searchProductData?.reduce(
        (acc: number, item: any) => acc + item.price,
        0
      );
      setTotalPrice(totalPrice.toFixed(2));
    } else {
      setTotalPrice("0.00");
    }
  }, [loading, searchProductData]);

  return (
    <PreviewOfPaymentModalWrapper>
      <PreviewOfPaymentModalContainer>
        <PreviewOfPaymentHeader>
          Preview of your payment link
        </PreviewOfPaymentHeader>
        <PreviewOfPaymentDetailsModal>
          <PreviewOfPaymentSubHeader>
            {selector.selectedProduct?.name}
          </PreviewOfPaymentSubHeader>
          <PreviewOfPaymentInfo>${totalPrice}</PreviewOfPaymentInfo>
          {totalPrice === "0.00" && (
            <div>
              <PreviewOfPaymentInfo>
                <img src="/assets/svg/CharityPreviewIcon.svg" alt="" />
              </PreviewOfPaymentInfo>
              <MainPreviewSubSpan>Product Description</MainPreviewSubSpan>
            </div>
          )}
          {searchProductData?.length > 0 && (
            <div>
              {searchProductData?.length > 0 &&
                searchProductData?.map((items: any) => (
                  <ProductDisplayContainer key={items?.id}>
                    <PreviewItemsContainer>
                      <PreviewOfPaymentImageField src={items?.images} alt="" />
                      <PreviewOfPaymentInformation>
                        <PreviewItemsTitle>{items?.name}</PreviewItemsTitle>
                        <PreviewItemsDescription>
                          {items?.description}
                        </PreviewItemsDescription>
                      </PreviewOfPaymentInformation>
                    </PreviewItemsContainer>
                    <PreviewPriceCont1>
                      <PreviewPriceText>${items?.price}</PreviewPriceText>
                    </PreviewPriceCont1>
                  </ProductDisplayContainer>
                ))}
            </div>
          )}
          <PreviewPaymentInputMain>
            <PreviewEmailContainer>
              <TextFields
                height="30px"
                type="email"
                placeholder="yours@gmail.com"
                fontSize={fipayFonts.fipayFonts.fontSize.body3}
                label="Email"
                value={data.email}
                onChange={(value: string) => handleNameChange("email", value)}
              />
            </PreviewEmailContainer>
            <br />
            {/* {phone number dropdown */}
            <PreviewPhoneBox>
              <Label htmlFor="countryCode">Phone Number</Label>
              <PreviewPaymentPhoneContainer>
                <PreviewSmallInput type="tel" placeholder="+1" />
                <PreviewLargeInput
                  value={phone}
                  onChange={handlePhoneChange}
                  type="number"
                />
              </PreviewPaymentPhoneContainer>
            </PreviewPhoneBox>

            {showAddress === "customerAddress" && (
              <PreviewTaxContainer>
                <TextFields
                  height="30px"
                  type="text"
                  placeholder="123-45-6789"
                  fontSize={fipayFonts.fipayFonts.fontSize.body3}
                  label="Tax Id"
                  value={data.taxId}
                  onChange={(value: string) => handleNameChange("taxId", value)}
                />
              </PreviewTaxContainer>
            )}
          </PreviewPaymentInputMain>

          {showAddress === "collectCustomersShippingAddress" && (
            <PreviewPaymentMainCon>
              <SpanStyles>Shipping information</SpanStyles>
              <PreviewPaymentContent1>
                <PreviewPaymentInput1
                  value={data.addressLine1}
                  name="addressLine1"
                  onChange={handleAddress}
                  placeholder="Address line 1"
                />
              </PreviewPaymentContent1>
              <PreviewPaymentContent2>
                <PreviewPaymentInput2
                  value={data.addressLine2}
                  name="addressLine2"
                  onChange={handleAddress}
                  placeholder="Address line 2"
                />
              </PreviewPaymentContent2>
              <PreviewPaymentContent3>
                <PreviewPaymentInput3
                  value={data.city}
                  name="city"
                  onChange={handleAddress}
                  placeholder="City"
                />
                <PreviewPaymentInput4
                  value={data.zip}
                  name="zip"
                  onChange={handleAddress}
                  placeholder="Zip"
                />
              </PreviewPaymentContent3>
            </PreviewPaymentMainCon>
          )}
          {showTaxInfo === "collectTaxAutomatically" && (
            <PreviewPaymentConfirmation>
              <PreviewAmount>
                <PreviewAmountTitle>Amount</PreviewAmountTitle>
                <PreviewAmountValue>$0.00</PreviewAmountValue>
              </PreviewAmount>
              <div></div>
              <PreviewAmount>
                <PreviewAmountTitle>Subtotal</PreviewAmountTitle>
                <PreviewAmountValue>$0.00</PreviewAmountValue>
              </PreviewAmount>
              <PreviewAmount>
                <PreviewAmountSmallTitle>Tax</PreviewAmountSmallTitle>
                <PreviewAmountSmallValue>$0.00</PreviewAmountSmallValue>
              </PreviewAmount>

              <PreviewAmount>
                <PreviewAmountTitle>Total</PreviewAmountTitle>
                <PreviewAmountValue>$0.00</PreviewAmountValue>
              </PreviewAmount>
            </PreviewPaymentConfirmation>
          )}
          <SelectPaymentOptionPaymentLink>
            <PaymentOptionsSelect>Select payment option</PaymentOptionsSelect>
            <PaymentWithAccount>
              <RadioButton
                checked={oneTimeChecked}
                onClick={handleOneTimeClick}
              />
              <PaymentWithCardSpan>Pay with account</PaymentWithCardSpan>
            </PaymentWithAccount>
            <PaymentWithAccount>
              <RadioButton
                checked={recurringChecked}
                onClick={handleRecurringClick}
              />
              <PaymentWithCardSpan>Pay with card</PaymentWithCardSpan>
            </PaymentWithAccount>
          </SelectPaymentOptionPaymentLink>
          <PreviewPaymentButtonContainer>
            <Buttons
              // handleClick={NavigateToTypeOfAccount}
              label="Pay"
              width="100%"
              color={colors.ButtonBackgroundColors.primaryMediumHoverButton}
              cursor="pointer"
              border="10px"
              height="45px"
              disabled={!isFormValid()}
            />
          </PreviewPaymentButtonContainer>
        </PreviewOfPaymentDetailsModal>
      </PreviewOfPaymentModalContainer>
    </PreviewOfPaymentModalWrapper>
  );
};

export default PreviewOfPayment;
